module.exports = __webpack_public_path__ + "img/v-p.6c61d942.svg";